/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIm } from '../../factoriesAny.js';
export var imDependencies = {
  typedDependencies: typedDependencies,
  createIm: createIm
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIm.generated.js
// module id = 1426
// module chunks = 0